import { useTranslation } from 'react-i18n-lite'

import styled from 'styled-components'

import { Icon, Text } from '@yes.technology/react-toolkit'

type States = 'no-data-to-view' | 'no-results-found' | 'no-state-selected'

interface EmptyStatesProps {
  state: States
  showComplement?: boolean
  style?: React.CSSProperties
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`

const EmptyStates = ({
  state,
  showComplement = true,
  style
}: EmptyStatesProps) => {
  const { t } = useTranslation()

  if (state === 'no-data-to-view') {
    return (
      <Container {...{ style }}>
        <Icon
          iconName='InputMissing'
          icSize='extraLarge'
          icColor='CESprimary'
        />
        <Text variant='content-emphasis-06'>
          {t('data.states.no-data-to-view.des')}
        </Text>
        {showComplement && (
          <Text variant='bordertext-04'>
            {t('data.states.no-data-to-view.complement')}
          </Text>
        )}
      </Container>
    )
  }

  if (state === 'no-results-found') {
    return (
      <Container {...{ style }}>
        <Icon iconName='Search' icSize='extraLarge' icColor='CESprimary' />
        <Text variant='content-emphasis-06'>
          {t('data.states.no-results-found.des')}
        </Text>
        {showComplement && (
          <Text variant='bordertext-04'>
            {t('data.states.no-results-found.complement')}
          </Text>
        )}
      </Container>
    )
  }

  if (state === 'no-state-selected') {
    return (
      <Container {...{ style }}>
        <Icon iconName='Search' icSize='extraLarge' icColor='CESprimary' />
        <Text variant='content-emphasis-06'>
          {t('data.states.no-state-selected.des')}
        </Text>
        {showComplement && (
          <Text variant='bordertext-04'>
            {t('data.states.no-state-selected.complement')}
          </Text>
        )}
      </Container>
    )
  }

  return null
}

export default EmptyStates
